import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COMPANY_INFO } from '../data/company';

const navigation = [
  { label: 'Hjem', href: '/' },
  { label: 'Ydelser', href: '/ydelser', children: [
    { label: 'Pillefyr', href: '/ydelser/pillefyr' },
    { label: 'Luft til luft', href: '/ydelser/luft-til-luft-varmepumpe' },
    { label: 'Luft til vand', href: '/ydelser/luft-til-vand-varmepumpe' },
    { label: 'Solceller', href: '/ydelser/solceller' },
    { label: 'Service', href: '/ydelser/varmepumpe-service' }
  ] },
  { label: 'Prisberegner', href: '/prisberegner' },
  { label: 'Kontakt', href: '/kontakt' }
];

export function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  const active = (href) => href === '/' ? location.pathname === '/' : location.pathname.startsWith(href);
  const navigationTone = isHome ? 'text-white/70 hover:text-white' : 'text-[#192330] hover:text-[#206FEA]';
  const navLinkClass = (href) => `relative inline-flex items-center py-2 text-[13px] font-semibold uppercase tracking-[0.1em] transition-colors after:absolute after:inset-x-0 after:bottom-0 after:h-px after:origin-left after:scale-x-0 after:bg-current after:transition-transform after:duration-300 hover:after:scale-x-100 ${active(href) ? `${isHome ? 'text-white' : 'text-[#006DDE]'} after:scale-x-100` : navigationTone}`;

  return (
    <header className={`z-50 w-full ${isHome ? 'absolute inset-x-0 top-0' : 'relative bg-white shadow-sm'}`}>
      <div className="bg-[#0B0E14] text-xs text-white/65">
        <div className="mx-auto flex min-h-11 max-w-[1640px] items-center justify-between px-5 sm:px-8 lg:px-12">
          <a href={COMPANY_INFO.facebookUrl} target="_blank" rel="noreferrer" aria-label="JNO Montage på Facebook" className="transition hover:text-white"><i className="fa-brands fa-facebook-f" aria-hidden="true" /></a>
          <div className="hidden items-center gap-6 md:flex">
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="transition hover:text-white"><i className="fa-light fa-phone mr-2 text-[#a8ad68]" aria-hidden="true" />{COMPANY_INFO.phone}</a>
            <a href={`mailto:${COMPANY_INFO.email}`} className="transition hover:text-white"><i className="fa-light fa-paper-plane mr-2 text-[#a8ad68]" aria-hidden="true" />{COMPANY_INFO.email}</a>
            <a href={COMPANY_INFO.findVejUrl} target="_blank" rel="noreferrer" className="transition hover:text-white"><i className="fa-light fa-location-dot mr-2 text-[#a8ad68]" aria-hidden="true" />{COMPANY_INFO.fullAddress}</a>
          </div>
          <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="md:hidden"><i className="fa-light fa-phone mr-2 text-[#a8ad68]" aria-hidden="true" />{COMPANY_INFO.phone}</a>
        </div>
      </div>
      <div className={`border-b ${isHome ? 'border-white/15' : 'border-[#E6EBEF]'}`}>
        <div className="mx-auto flex h-24 max-w-[1640px] items-center justify-between px-5 sm:px-8 lg:px-12">
          <Link to="/" className="block">
            <img src={isHome ? COMPANY_INFO.logoWhiteUrl : COMPANY_INFO.logoDarkUrl} alt="JNO Montage" className="h-9 w-auto sm:h-10" />
          </Link>
          <nav className="hidden items-center gap-8 lg:flex">
            {navigation.map((item) => item.children ? (
              <div key={item.href} className="group relative py-9" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
                <Link to={item.href} className={navLinkClass(item.href)}>
                  {item.label} <i className={`fa-light fa-chevron-down ml-1 text-[10px] transition-transform ${servicesOpen ? 'rotate-180' : ''}`} aria-hidden="true" />
                </Link>
                <div className={`absolute right-0 top-[76px] w-60 border border-[#006DDE]/15 bg-white p-2 shadow-[0_18px_45px_rgba(18,35,51,0.16)] transition ${servicesOpen ? 'visible translate-y-0 opacity-100' : 'invisible -translate-y-1 opacity-0'}`}>
                  <p className="px-3 pb-2 pt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#006DDE]">Vores ydelser</p>
                  {item.children.map((child) => <Link key={child.href} to={child.href} className={`group/item flex items-center justify-between border-t border-[#E6EBEF] border-l-2 px-3 py-3 text-sm font-medium transition ${active(child.href) ? 'border-l-[#206FEA] bg-[#206FEA]/10 text-[#206FEA] shadow-[inset_3px_0_0_rgba(32,111,234,0.14)]' : 'border-l-transparent text-[#192330] hover:bg-[#E6EBEF] hover:text-[#206FEA]'}`}><span>{child.label}</span><i className="fa-light fa-arrow-right text-xs opacity-0 transition group-hover/item:translate-x-0.5 group-hover/item:opacity-100" aria-hidden="true" /></Link>)}
                </div>
              </div>
            ) : <Link key={item.href} to={item.href} className={navLinkClass(item.href)}>{item.label}</Link>)}
          </nav>
          <button type="button" onClick={() => setMobileOpen((open) => !open)} aria-label="Åbn menu" aria-expanded={mobileOpen} className={`rounded-xl p-2 text-xl lg:hidden ${isHome ? 'text-white' : 'text-[#0B0E14]'}`}><i className={`fa-light ${mobileOpen ? 'fa-xmark' : 'fa-bars'}`} aria-hidden="true" /></button>
        </div>
      </div>
      {mobileOpen && (
        <div className="border-b border-[#E6EBEF] bg-white px-5 py-5 shadow-lg lg:hidden">
          <nav className="mx-auto flex max-w-[1640px] flex-col">
            {navigation.map((item) => (
              <React.Fragment key={item.href}>
                <Link
                  to={item.href}
                  className={`border-b border-[#E6EBEF] py-3 text-sm font-semibold uppercase tracking-[0.08em] ${
                    active(item.href) ? 'text-[#206FEA]' : 'text-[#0B0E14]'
                  }`}
                >
                  {item.label}
                </Link>
                {item.children?.map((child) => {
                  const isChildActive = location.pathname === child.href;
                  return (
                    <Link
                      key={child.href}
                      to={child.href}
                      className={`my-0.5 flex items-center justify-between rounded-r-lg border-l-2 py-2.5 pl-4 pr-3 text-sm font-medium transition ${
                        isChildActive
                          ? 'border-l-[#206FEA] bg-[#206FEA]/10 text-[#206FEA] font-semibold shadow-[inset_3px_0_0_rgba(32,111,234,0.14)]'
                          : 'border-l-transparent text-[#4B5563] hover:bg-[#E6EBEF]/60 hover:text-[#206FEA]'
                      }`}
                    >
                      <span>{child.label}</span>
                      {isChildActive && (
                        <i className="fa-light fa-chevron-right text-xs text-[#206FEA]" aria-hidden="true" />
                      )}
                    </Link>
                  );
                })}
              </React.Fragment>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
